import React from "react";

export default function ProductCard({
  product,
  valueProps = [],
  title = "Markets",
  tagline,
}) {
  return (
    <div className="w-full md:w-1/2 flex flex-col">
      <div className="m-4 shadow-xl flex flex-col h-full border border-gray-300">
        <div className="bg-gray-112 z-1">
          <h2
            className="text-theme-red text-center uppercase font-extrabold text-lg px-2 py-4"
            dangerouslySetInnerHTML={{ __html: product.title }}
          />
          {tagline && typeof tagline === "string" && (
            <div className="text-center pb-2">
              {tagline.replace(/<[^>]+>/g, "")}
            </div>
          )}
        </div>
        <div className="pb-4 px-3 flex-grow">
          <div className="flex py-4">
          <div className=" w-1/3">
            <div className="flex flex-wrap">
              <div className="flex-grow">
                <div className="product-tg block lg:inline-block px-2 xl:px-4 ">
                  <strong>Tg: </strong>
                  <span dangerouslySetInnerHTML={{ __html: product.tg }} />
                  &#176;C
                </div>
              </div>
            </div>
            <div className="flex flex-wrap">
              <div className="flex-grow">
                <div className="product-td block lg:inline-block px-2 xl:px-4 ">
                  <strong>Td: </strong>
                  <span dangerouslySetInnerHTML={{ __html: product.td }} />
                  &#176;C
                </div>
              </div>
            </div>
          </div>
          <div className=" w-2/3">
            <div className="flex flex-wrap">
              <div className="flex-grow">
                <div className="product-dk block lg:inline-block px-2 xl:px-4 ">
                  <strong>Dk: </strong>
                  <span dangerouslySetInnerHTML={{ __html: product.dk }} />
                </div>
              </div>
            </div>
            <div className="flex flex-wrap">
              <div className="flex-grow">
                <div className="product-df block lg:inline-block px-2 xl:px-4 ">
                  <strong>Df: </strong>
                  <span dangerouslySetInnerHTML={{ __html: product.df }} />
                </div>
              </div>
            </div>
          </div>
          </div>
          <hr className="pb-5" />

          {valueProps &&
            typeof valueProps === "object" &&
            valueProps.length > 0 && (
              <>
                <h3 className="px-4">{title}</h3>
                <div className="flex flex-wrap flex-row justify-around m-2 py-1">
                  {valueProps.map((m) => {
                    if (!m.icon) {
                      return null;
                    }
                    return (
                      <div key={m.id} className="product-markets">
                        <img
                          className="h-12 w-auto m-1"
                          src={m.icon}
                          alt="market icon"
                        />
                      </div>
                    );
                  })}
                </div>
              </>
            )}
        </div>
        <a
          href={product.link}
          className="view-details block py-3 px-3 text-center bg-red z-1"
        >
          View Details
        </a>
      </div>
    </div>
  );
}
